import DOMPurify from 'isomorphic-dompurify';

export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function normalizeAnchorId(value: string): string {
  const normalized = value
    .trim()
    .toLowerCase()
    .replace(/[\s\r\n\t]+/g, '-')
    .replace(/['"<>#%\{\}\|\\\^~\[\]`?;@=&]/g, '')
    .replace(/^-+|-+$/g, '');

  return normalized || 'section';
}

// <a> タグに rel="noopener noreferrer" を付与するフックを設定
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName && node.tagName.toLowerCase() === 'a' && node.hasAttribute('href')) {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

/**
 * XSS脆弱性を防ぐため、HTML内の危険なタグや属性を除去します。
 * isomorphic-dompurify を使用して堅牢なサニタイズを行います。
 */
export function sanitizeHtml(html: string): string {
  // 許可するタグ一覧
  const ALLOWED_TAGS = [
    'h1',
    'h2',
    'h3',
    'p',
    'span',
    'br',
    'div',
    'img',
    'ruby',
    'rt',
    'a',
    'strong',
    'em',
    'del',
  ];

  // 許可する属性とタグの組み合わせ
  // DOMPurify では ALLOWED_ATTR で全体の許可属性を指定し、
  // 必要に応じて FORBID_ATTR やカスタムフックで制限します。
  const ALLOWED_ATTR = [
    'class',
    'id',
    'aria-hidden',
    'href',
    'data-section-link',
    'rel',
    'src',
    'alt',
    'loading',
  ];

  try {
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS,
      ALLOWED_ATTR,
      // KEEP_CONTENT が true (デフォルト) の場合、許可されていないタグは削除されるが、
      // その中身のテキストは保持されます。
      KEEP_CONTENT: true,
      // data URI や不正なプロトコルを防ぐ (デフォルトで保護されていますが明示)
      ALLOW_DATA_ATTR: false,
    });
  } catch (e) {
    console.error('HTML sanitize error:', e);
    return '';
  }
}
